import React from "react";
import TextField from "@mui/material/TextField";
import { NumericFormat } from "react-number-format";
import { InputAdornment } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import NumbersIcon from "@mui/icons-material/Numbers";
import PercentIcon from "@mui/icons-material/Percent";

export default function SimuladorNumericInput({
  value: propValue = "",
  onChange: propOnChange,
  label = "",
  name = "monto",
  disabled = false,
  max = 1000000000,
  icono = "pesos",
  align = "izquierda",
  inputTotal = "no",
  className = "",
}) {
  const [value, setValue] = React.useState(propValue);

  React.useEffect(() => setValue(propValue), [propValue]);

  const startAdornment =
    icono === "pesos" ? (
      <InputAdornment position="start">
        <AttachMoneyIcon fontSize="small" />
      </InputAdornment>
    ) : icono === "numero" ? (
      <InputAdornment position="start">
        <NumbersIcon fontSize="small" />
      </InputAdornment>
    ) : null;

  const endAdornment =
    icono === "porcentaje" ? (
      <InputAdornment position="end">
        <PercentIcon fontSize="small" />
      </InputAdornment>
    ) : null;

  const textAlign =
    align === "izquierda" ? "left" : align === "centro" ? "center" : "right";
  return (
    <NumericFormat
      value={value}
      onValueChange={(values) => {
        setValue(values.value);
        if (propOnChange)
          propOnChange({ target: { name, value: values.value } });
      }}
      thousandSeparator=","
      decimalSeparator="."
      decimalScale={2}
      allowNegative={false}
      isAllowed={(v) => {
        const { floatValue } = v;
        return floatValue === undefined || floatValue <= max;
      }}
      color="success"
      customInput={TextField} // ✅ TextField interno, no externo
      label={label}
      name={name}
      variant="outlined"
      fullwidth
      size="small"
      disabled={disabled}
      className={`${className} disabled && "simulador-incentivo-form-input-disabled"`}
      InputProps={{
        ...(inputTotal === "si"
          ? {
            sx: {
              background: "#f1f9f5",
              borderRadius: "10px",
              "& input": {
                textAlign: "center",
                color: "black",
                fontWeight: "bold",
                fontSize: "22px",
              },
              "& .MuiInputAdornment-root svg": {
                color: "black",
                fontSize: "20px",
                fontWeight: "bold",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#b5dfc8 !important",
                borderRadius: "10px",
              },
            },
          }
          : {
            sx: {
              "& input": { textAlign },
              "& .MuiOutlinedInput-notchedOutline": {
                borderRadius: "10px",
                overflow: "hidden",
              },
            },
          }),
        startAdornment,
        endAdornment,
      }}
    />
  );
}
